<template>
        <div>
        <div v-if="contentLoading">
            <Loading/>
        </div>
        <b-row  v-else>
            <b-col xl="6">
                <CustomCard  ref="rtDepartureGeneration" :title="$t('system.maintenance.labels.rtDepartureGeneration')" @clickedButton="rtDepartureGeneration()">
                    <template slot="content">
                        <b-card-text v-if="!contentLoading"  >
                            <b-row>
                                <b-col>{{ $t('system.maintenance.rtDepartureStatus.version') }}</b-col>
                                <b-col>{{ this.returnRtDepartureStatusDetail(this.rtDepartureStatus.rtDepVersion) }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col>{{ $t('system.maintenance.rtDepartureStatus.generatorRunning') }}</b-col>
                                <b-col>{{ this.returnRtDepartureStatusDetail(this.rtDepartureStatus.rtgeneratorRunning) }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col>{{ $t('system.maintenance.rtDepartureStatus.lastDropTime') }}</b-col>
                                <b-col>{{ this.formatDate(this.rtDepartureStatus.dropTime) }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col>{{ $t('system.maintenance.rtDepartureStatus.lastGenerationTime') }}</b-col>
                                <b-col>{{ this.formatDate(this.rtDepartureStatus.generateTime) }}</b-col>
                            </b-row>
                        </b-card-text>
                    </template>
                </CustomCard>
            </b-col>

            <b-col xl="6">

                <CustomCard ref="softwareStatus" :title="$t('system.maintenance.softwareStatus')" :hideButton="true">
                    <template slot="content">
                        <b-row v-if="!contentLoading">
                            <b-col>{{ $t('system.maintenance.lastTravellerUpdate') }}</b-col>
                            <b-col>{{ this.formatDate(this.travellerBuildTime) }}</b-col>
                        </b-row>
                    </template>
                </CustomCard>
            </b-col>

             <b-col xl="4">
                <CustomCard ref="softwareStatus" :title="$t('system.settings.loglevel.header')" :hideButton="true" :hideRequestInfo="true">
                    <template slot="content">
                        <LogLevel/>
                    </template>
                </CustomCard>
            </b-col>

            <b-col xl="4">
                <CustomCard ref="gtfsExport" :title="$t('system.maintenance.labels.gtfsExport')" @clickedButton="gtfsExport()">
                </CustomCard>
            </b-col>



            <b-col xl="4">
                <CustomCard ref="updateBlockSequenceTimes" :title="$t('system.maintenance.labels.updateBlockSequenceTimes')" @clickedButton="updateBlockSequenceTimes()">
                </CustomCard>
            </b-col>
           

            <b-col xl="4">
                <CustomCard ref="copyTimetableToRTraveller" :title="$t('system.maintenance.labels.copyTimetableToRTraveller')" @clickedButton="copyTimetableToRTraveller()">
                </CustomCard>
             </b-col>
           

            <b-col xl="4">
                <CustomCard ref="sendDrivingCycles" :title="$t('system.maintenance.labels.sendDrivingCycles')" @clickedButton="sendDrivingCycles()">
                </CustomCard>
            </b-col>


            <b-col xl="4">
                <CustomCard ref="import" :title="$t('system.maintenance.labels.import')" @clickedButton="runImport()">
                    <template slot="button_content">
                        <vSelect
                            :options="timetableImportList"
                            v-model="selectedTimetableImport"
                            :placeholder="$t('system.maintenance.selectImportType')"
                            :clearable="false"/>
                    </template>
                </CustomCard>
            </b-col>


            <b-col xl="4">
                <CustomCard ref="updateStopLocationsOnRouteShapes" :title="$t('system.maintenance.labels.updateStopLocationsOnRouteShapes')"
                    @clickedButton="updateStopLocationsOnRouteShapes()">
                </CustomCard>
             </b-col>

            <b-col xl="4">
                <CustomCard ref="openSearchDashboards" :title="$t('system.maintenance.labels.openSearchDashboards')" :hideButton="true">
                    <template slot="content">
                        <b-card-text>
                            <a v-if="openSearchUrl" :href="openSearchUrl" target="_blank" class="btn btn-primary">
                                {{ $t('system.maintenance.labels.openDashboards') }}
                            </a>
                            <span v-else>{{ $t('system.maintenance.labels.openSearchNotConfigured') }}</span>
                        </b-card-text>
                    </template>
                </CustomCard>
            </b-col>

        </b-row>
        </div>
</template>

<script>
import maintenance from '@/store/system/maintenance'
import osdFeatures from '@/store/organization/osdFeatures'
import moment from 'moment';
import vSelect from 'vue-select'
import CustomCard from '@/components/System/CustomCard'
import LogLevel from '@/components/System/Settings/LogLevel'

export default {
    name: 'Maintenance',
    components: {
        vSelect, CustomCard, LogLevel
    },
    data: function() {
      return {
        contentLoading: true,
        selectedTimetableImport: null,
        intervalFetchData: null
      }
    },
    computed: {
      rtDepartureStatus() {
            return this.$store.state.maintenance.rtGenerateStatus;
        },
      travellerBuildTime() {
          return this.$store.state.maintenance.travellerBuildTime;
      },
      timetableImportList() {
          return this.$store.state.maintenance.timetableImportList;
      },
      openSearchUrl() {
          const baseUrl = this.$UiConfig('/ui/opensearchUrl', '')
          if (!baseUrl) return null
          
          const jwtToken = this.$store.state.osdFeatures?.jwtToken
          if (!jwtToken) return baseUrl
          
          const hashIndex = baseUrl.indexOf('#')
          const urlWithoutHash = hashIndex === -1 ? baseUrl : baseUrl.substring(0, hashIndex)
          
          return `${urlWithoutHash}?jwt=${jwtToken}`
      }
    },
    methods: {
      returnRtDepartureStatusDetail(value){
        return value != null ? value : "-";
      },
      gtfsExport(){
          this.$store.dispatch('maintenance/startGtfsExport')
            .then((response) => {
                this.$refs.gtfsExport.handleResponse(response);

            })
      },
      rtDepartureGeneration(){
          this.$store.dispatch('maintenance/startRtGeneration')
            .then((response) => {
                this.$refs.rtDepartureGeneration.handleResponse(response);

            })
      },
      updateBlockSequenceTimes(){
          this.$store.dispatch('maintenance/updateBlockSequences')
            .then((response) => {
                this.$refs.updateBlockSequenceTimes.handleResponse(response);
            })
      },
      copyTimetableToRTraveller(){
          this.$store.dispatch('maintenance/startTimetableCopyToRT')
            .then((response) => {
                this.$refs.copyTimetableToRTraveller.handleResponse(response);
            })
      },
      sendDrivingCycles(){
          this.$store.dispatch('maintenance/sendDrivingCycles')
            .then((response) => {
                this.$refs.sendDrivingCycles.handleResponse(response);
            })
      },
      runImport(){
        if(this.selectedTimetableImport == null) {
            this.$refs.import.requestLoading = false;
            this.$refs.import.error = true;
            this.$refs.import.errorMsg = this.$t('system.maintenance.selectImportType');
            return;
        }
        let params = {"importName" : this.selectedTimetableImport}
        this.$store.dispatch('maintenance/runTimetableImport', params)
            .then((response) => {
                this.$refs.import.handleResponse(response);
            })
      },
        updateStopLocationsOnRouteShapes() {
            this.$store.dispatch('maintenance/updateStopLocationsOnRouteShapes')
            .then((response) => {
                this.$refs.updateStopLocationsOnRouteShapes.handleResponse(response);
            })
        },
      fetchData(){
        this.$store.dispatch('maintenance/getTravellerBuildTime');

        this.$store.dispatch('maintenance/getRtGenerateStatus').then(() => {
            this.contentLoading = false;
        }); 
      },
      formatDate(date){
          if (date != null)
            return new moment(date, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('YYYY-MM-DD HH:mm:ss')
          return "-";
      }

    },
    beforeCreate: async function() {
        if (!this.$store.state.maintenance) {
            this.$store.registerModule("maintenance", maintenance);
        }
        if (!this.$store.state.osdFeatures) {
            this.$store.registerModule('osdFeatures', osdFeatures)
        }
        await this.$store.dispatch('osdFeatures/getOsdFeatureList')
    },
    created: function() {
        this.contentLoading = true;
        this.$store.dispatch('maintenance/getTimetableImportList');

        this.fetchData();
        this.intervalFetchData = setInterval(() => {
            this.fetchData();
        }, 10000)
    },
    beforeDestroy() {
        if(this.intervalFetchData != null)
            clearInterval(this.intervalFetchData)
    }
}
</script>


<style scoped lang="scss">


.custom_card .row {
    font-size: 0.9rem;
    white-space: pre-wrap;
    margin-bottom: 5px;
}
.custom_card .col {
    border-bottom: 1px solid #cecece;
}


.col:first-child {
    font-weight: bold;
}


</style>